import React from 'react';
import { FormHeader } from '@snsw-gel/react';
import { getStepListContent, getActiveStepListTitle } from './stepsListContent';
import styled from 'styled-components';
import {StepsLabel} from '../../../config/stepsLabel';

import config from '../../../config/config';

const FormHeaderWrapper = styled.div`
    margin-bottom: -3.5rem;
`;

interface HeaderStepperProps {
    readonly step?: number;
    /** Optional override for header title if it doesn't match the step */
    readonly headerTitle?: string;
}

const HeaderStepper: React.FC<HeaderStepperProps> = (
    {
        step,
        headerTitle,
    }
) => {

    return (
        <FormHeaderWrapper>
            <FormHeader
                label={config.appTitle}
                stepsList={getStepListContent(StepsLabel, step ?? 0)}
                title={headerTitle ?? getActiveStepListTitle()}
            />
        </FormHeaderWrapper>
    );
};

export default HeaderStepper;
